/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2017 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/**
 * @file
 */

import React from 'react';
import { MemoryRouter, Route } from 'react-router-dom';

/**
 * @description
 * If component is already a descendant of a router, return it. Otherwise,
 * return it wrapped in a MemoryRouter so that its react-router components
 * (Route, Link, et al) continue to work.
 * @method
 * @param {object} props - Props passed to component
 * @param {function} component - Target component
 * @returns {object} - Either component itself or component wrapped in MemoryRouter
 * @public
 */
function withMemoryRouter(props, component) {
  const Comp = component;
  if (!props.match) {
    return (
      <MemoryRouter>
        <Route render={routeProps => <Comp {...props} {...routeProps} />} />
      </MemoryRouter>
    );
  }
  return React.createElement(Comp, props);
}

// eslint-disable-next-line import/prefer-default-export
export { withMemoryRouter };
